import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prettyIban',
    standalone: false
})
export class PrettyIbanPipe implements PipeTransform {
    transform(value: string): string {
        return value ?
            value.split(' ').join('').replace(/(.{4})/g, '$1 ').toUpperCase() :
            value;
    }
}
